export const addLeafletCompassControl = (leaflet, map, options = {}) => {
  if (!leaflet || !map) {
    return null;
  }

  const {
    position = 'topright',
    title = 'Brujula: el mapa mantiene el norte hacia arriba.',
  } = options;

  const CompassControl = leaflet.Control.extend({
    options: {
      position,
    },

    onAdd() {
      const container = leaflet.DomUtil.create('div', 'leaflet-control map-compass-control');
      container.setAttribute('role', 'img');
      container.setAttribute('aria-label', title);
      container.setAttribute('title', title);
      container.innerHTML = `
        <div class="map-compass-control__face" aria-hidden="true">
          <span class="map-compass-control__north">N</span>
          <span class="map-compass-control__needle map-compass-control__needle--north"></span>
          <span class="map-compass-control__needle map-compass-control__needle--south"></span>
        </div>
      `;

      leaflet.DomEvent.disableClickPropagation(container);
      leaflet.DomEvent.disableScrollPropagation(container);
      return container;
    },
  });

  const control = new CompassControl();
  control.addTo(map);
  return control;
};
